import {Text} from '#component/base';
import {MAIN_CONTENT_NODE_ID} from '#constant/app';

import * as css from './SkipToContentButton.css';

export const SkipToContentButton = () => (
  <Text
    as="a"
    href={`#${MAIN_CONTENT_NODE_ID}`}
    className={css.root}
    color="deepBurgundy"
    transform="uppercase"
    variant="caption">
    Skip to content
  </Text>
);
